import React from 'react';
import { Header } from '../Common/Header';
import { Footer } from '../Common/Footer';
import { Link, } from 'react-router-dom';
import ProductsUpload from '../../Models/ProductsUpload';
import { SubCategoriesShowProducts } from './SubCategoriesShowProducts';
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';
import 'rc-menu/assets/index.css';

class subCategory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsCountPerPage: 5,
            pageRangeDisplayed: 3,
            categories: [],
            categoryProducts: [],
            allProducts: [],
            total: [],
            code: 0,
            refCode: ''
        };
        this.getCategory();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        let url = window.location.pathname.split('/');
        let id = url[url.length - 1]
        this.setState({ refCode: id })
    }
    componentWillMount() {
        let url = window.location.pathname.split('/');
        let id = url[url.length - 1]
        this.setState({ refCode: id })
    }
    getCategory() {
        ProductsUpload.getCategory().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }
    handleClick(id) {
        this.setState({ refCode: id });
        this.props.history.push(`/sub-categories/${id}`);
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <div className="container">
                        <Header />
                    </div>
                    <div className="container-fluid">
                        <div className="col-md-12 tr_blank_medium mt-5 pt-2"> </div>
                        <div className="col-md-12 tr_blank_medium mt-5 "> </div>
                        <div className="row">
                            <div className="col-md-12 large_fonts">
                                <SubCategoriesShowProducts id={this.state.refCode} />
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <div className="container">
                        <Header />
                    </div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12 tr_blank_medium mt-5 pt-4"> </div>
                            <div className="col-md-12 tr_blank_medium mt-5 pt-4 small-hidden"> </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-3 remember_text small-hidden">
                                                <div style={{ fontSize: '12px' }}>
                                                    <Menu style={{ border: '0px solid #d9d9d9', cursor: 'pointer' }}>
                                                        {this.state.categories.map(data => {
                                                            if (data.sub_category.length === 0)
                                                                return (<MenuItem key={data.id} style={{ cursor: 'pointer' }}>
                                                                    <Link to={{
                                                                        pathname: `/sub-categories/${data.id}`,
                                                                        state: { id: data.id }
                                                                    }} className="category-right" style={{ fontSize: '12px' }}>{data.category}</Link>
                                                                </MenuItem>)

                                                            return (
                                                                <SubMenu title={data.category} key={data.category} style={{ paddingTop: "5px !important", paddingBottom: "5px !important" }}>
                                                                    {data.sub_category.map((subcat) => {
                                                                        return (
                                                                            <MenuItem key={subcat.id} style={{ cursor: 'pointer' }} onClick={this.handleClick.bind(this, subcat.id)}>
                                                                                {/* {console.log(subcat.id)} */}
                                                                                <div className="category-right" >
                                                                                    {/* <Link to={{ pathname: `/sub-categories/${subcat.id}` }} className="category-right"> */}
                                                                                    {subcat.cat_name}
                                                                                    {/* </Link> */}
                                                                                </div>
                                                                            </MenuItem>
                                                                        )
                                                                    })}
                                                                </SubMenu>)
                                                        })}
                                                    </Menu>
                                                </div>
                                                <div>&nbsp;</div>
                                            </div>
                                            <div className="col-md-9 large_fonts">
                                                <SubCategoriesShowProducts id={this.state.refCode} />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-1"></div> */}
                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        }
    }
}
export { subCategory }
